module.exports = __webpack_public_path__ + "static/media/vuong.875f5ee7.png";